import {
  RegistrationFormStatus,
  RequestStatus,
  RegistrationForm,
  Request,
} from "../models/Request";

// Provjera za botun "Potvrdi potpis jednog roditelja/skrbnika"
export const isApproveOneSignatureDisabled = (
  registrationForm: RegistrationForm,
  item: Request
) => {
  return (
    registrationForm.status?.id !==
      RegistrationFormStatus.FirstSignatureInProgress ||
    item.statusId !== RequestStatus.RegistrationFormCreated
  );
};

// Provjera za botun "Potvrdi potpis oba roditelja/skrbnika"
export const isApproveTwoSignaturesDisabled = (
  registrationForm: RegistrationForm,
  item: Request
) => {
  return (
    registrationForm.status?.id !==
      RegistrationFormStatus.SecondSignatureInProgress ||
    item.statusId !== RequestStatus.RegistrationFormCreated ||
    !item.otherParentDetails
  );
};

// Provjera za botun "Pošalji na potpis drugom roditelju/skrbniku"

export const isSecondSignatureInProgressDisabled = (
  registrationForm: RegistrationForm,
  item: Request
) => {
  const { status } = registrationForm;
  const invalidSignatureStatuses = [
    RegistrationFormStatus.OneSignature,
    RegistrationFormStatus.OneSignatureDigitalConfirmation,
  ];

  return (
    !status?.id ||
    !invalidSignatureStatuses.includes(status.id) ||
    item.statusId !== RequestStatus.RegistrationFormCreated ||
    !item.otherParentDetails
  );
};

// Provjera za botun "Potvrdi dovoljan broj potpisa na upisnici"
export const isApproveAllSignaturesDisabled = (
  registrationForm: RegistrationForm,
  item: Request
) => {
  const { status } = registrationForm;
  const validSignatureStatuses = [
    RegistrationFormStatus.FirstSignatureInProgress,
    RegistrationFormStatus.SecondSignatureInProgress,
  ];
  return (
    !status?.id ||
    validSignatureStatuses.includes(status.id) ||
    item.statusId !== RequestStatus.RegistrationFormCreated
  );
};
